import * as Actions from '../actions/actionTypes';

const initialState = {
    isFetching: false,
    contentCreated: false,
    error:false,
    message : '',
    contentData:[]
  };
  
  // receiving response sent by action according to type of action
  export default function premiumContentReducers(state = initialState, action) {
      //console.log(action,'action');
      let { payload } = action;
    switch (action.type) {
      case Actions.CREATECONTENTREQUEST:
        return { 
            isFetching: true,
            contentCreated: false,
            error:false,
            contentData:[],
            message : ''
        };
        break;
  
      case Actions.CREATECONTENTSUCCESS:
        return { 
            isFetching: false,
            contentCreated: true,
            error:false,
            message : payload.message,
            contentData: payload 
        };
        break;
  
      case Actions.CREATECONTENTERROR:
        return { 
            isFetching: false,
            contentCreated: false,
            error:true,
            contentData: payload,
            message : payload.message,

         };
        break;
        break;

      default:
        return state;
    }
  }
  